import { useForceUpdate } from "@mantine/hooks";
export default useForceUpdate;
